import { ragFetch } from "@/lib/api/rag-client";
import type { KnowledgeScopeOptions } from "./knowledge-scope";

export async function fetchKnowledgeScopeOptions(): Promise<KnowledgeScopeOptions> {
  const payload = await ragFetch<KnowledgeScopeOptions>("/api/retrieve/scope-options");
  return {
    workspaces: Array.isArray(payload.workspaces)
      ? payload.workspaces.map((workspace) => ({
          id: String(workspace.id),
          name: String(workspace.name ?? "Workspace"),
          libraries: Array.isArray(workspace.libraries)
            ? workspace.libraries.map((library) => ({
                id: String(library.id),
                name: String(library.name ?? "Library"),
              }))
            : [],
        }))
      : [],
    publicLibraries: Array.isArray(payload.publicLibraries)
      ? payload.publicLibraries.map((library) => ({
          id: String(library.id),
          name: String(library.name ?? "Library"),
        }))
      : [],
  };
}
